module.exports = __webpack_public_path__ + "img/img_offreur3.bc51d8fe.jpg";